module.exports = __webpack_public_path__ + "static/media/sologo.31d8346b.png";